const API_BASE = '/api';

function extractErrorMessage(data, status) {
  if (!data || typeof data !== 'object') {
    return `请求失败 (${status})`;
  }
  if (typeof data.error === 'string' && data.error) {
    return data.error;
  }
  const detail = data.detail;
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  return `请求失败 (${status})`;
}

function authHeaders() {
  try {
    const token = window.localStorage.getItem('token');
    if (token && token !== 'null' && token !== 'undefined' && token !== '') {
      return { Authorization: token };
    }
  } catch {
    // ignore
  }
  return {};
}

async function request(path) {
  const response = await fetch(`${API_BASE}${path}`, { headers: authHeaders() });
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `请求失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

async function postForm(path, form) {
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      body: form,
      headers: authHeaders(),
    });
  } catch {
    return { ok: false, error: '网络异常，上传失败' };
  }
  const raw = await response.text();
  let data;
  try {
    data = raw ? JSON.parse(raw) : {};
  } catch {
    return { ok: false, error: `请求失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function waitJob(jobId, onProgress) {
  for (;;) {
    const resp = await request(`/settlement-gen/jobs/${encodeURIComponent(jobId)}`);
    if (!resp.ok) return resp;
    const percent = Number(resp.percent) || 0;
    const message = resp.message || '';
    if (typeof onProgress === 'function') {
      onProgress(percent, message);
    }
    if (resp.status === 'running') {
      await sleep(250);
      continue;
    }
    if (resp.status === 'error') {
      return { ok: false, error: resp.error || resp.message || '操作失败' };
    }
    return { ok: true, ...(resp.result || {}) };
  }
}

export const settlementProcessApi = {
  async probeSheets(file, mode = 'generate') {
    const safeName = (file?.name || '').trim() || 'upload.xlsx';
    const form = new FormData();
    form.append('file', file, safeName);
    form.append('original_name', safeName);
    form.append('mode', mode || 'generate');
    return postForm('/settlement-gen/sheets', form);
  },
  async generate(file, projectName, wbsCode, sheetName, onProgress) {
    const safeName = (file?.name || '').trim() || 'upload.xlsx';
    const form = new FormData();
    form.append('file', file, safeName);
    form.append('original_name', safeName);
    form.append('project_name', projectName || '');
    form.append('wbs_code', wbsCode || '');
    form.append('sheet_name', sheetName || '');
    const started = await postForm('/settlement-gen/generate', form);
    if (!started.ok) return started;
    if (!started.jobId) return started;
    if (typeof onProgress === 'function') {
      onProgress(started.percent || 0, started.message || '准备中...');
    }
    return waitJob(started.jobId, onProgress);
  },
  async restore(file, sheetName, onProgress) {
    const safeName = (file?.name || '').trim() || 'upload.xlsx';
    const form = new FormData();
    form.append('file', file, safeName);
    form.append('original_name', safeName);
    form.append('sheet_name', sheetName || '');
    const started = await postForm('/settlement-gen/restore', form);
    if (!started.ok) return started;
    if (!started.jobId) return started;
    if (typeof onProgress === 'function') {
      onProgress(started.percent || 0, started.message || '准备中...');
    }
    return waitJob(started.jobId, onProgress);
  },
  downloadUrl: (filename) => `${API_BASE}/settlement-gen/download/${encodeURIComponent(filename)}`,
  listRecords: (keyword = '', limit = 50, offset = 0) => {
    const query = new URLSearchParams({
      keyword: keyword || '',
      limit: String(limit),
      offset: String(offset),
    });
    return request(`/settlement-gen/records?${query.toString()}`);
  },
  getRecord: (recordId) => request(`/settlement-gen/records/${encodeURIComponent(recordId)}`),
};
